import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import {
  provideHttpClient,
  HTTP_INTERCEPTORS,
  withInterceptorsFromDi,
} from '@angular/common/http'; // ✅ New Angular 18 way
import { SiteLayoutComponent } from './layout/site-layout/site-layout.component';
import { SiteHeaderComponent } from './layout/site-header/site-header.component';
import { AppLayoutComponent } from './layout/app-layout/app-layout.component';
import { AppSidebarComponent } from './layout/app-sidebar/app-sidebar.component';
import { AppHeaderComponent } from './layout/app-header/app-header.component';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { ErrorInterceptor, JwtInterceptor } from './_helpers';
import { SharedModule } from './_shared/shared.module';
import { EditProfileComponent } from './layout/app-header/edit-profile/edit-profile.component';
import { ChangePasswordModalComponent } from './layout/app-header/change-password-modal/change-password-modal.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { NgSelectModule } from '@ng-select/ng-select';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';
import { LoadingBarModule } from '@ngx-loading-bar/core';
import { TooltipConfig } from 'ngx-bootstrap/tooltip';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';


//Set the Globaly Tooltip Setting
export const sportsVisionTooltipConfig=(): TooltipConfig => {
  const tool_config = new TooltipConfig();
  tool_config.container = 'body'; 
  tool_config.placement = 'top';
  tool_config.adaptivePosition = false; 
  return tool_config;
}

@NgModule({
  declarations: [
    AppComponent,
    SiteHeaderComponent,
    SiteLayoutComponent,
    AppLayoutComponent,
    AppSidebarComponent,
    AppHeaderComponent,
    EditProfileComponent,
    ChangePasswordModalComponent,
  ],
  imports: [
    BrowserModule,
    LoadingBarRouterModule,  // 👈 Tracks route changes only
    LoadingBarModule,
    SharedModule,
    AppRoutingModule,
    NgScrollbarModule,
    NgSelectModule,
    BrowserAnimationsModule, // required by ngx-toastr
    ToastrModule.forRoot({
      timeOut: 3000, // default timeout
      positionClass: 'toast-bottom-right', // position of the toast
      preventDuplicates: true,
      closeButton: true,
      progressBar: true,
    }),
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatMenuModule,
    MatButtonModule,
    BsDropdownModule.forRoot()
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    provideCharts(withDefaultRegisterables()),
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: TooltipConfig, useFactory: sportsVisionTooltipConfig }
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
